import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatCalendarHeader } from '@angular/material/datepicker';

import { TranslateService } from '@ngx-translate/core';

import { IconComponent, IconName } from '../../icon';

@Component({
  selector: 'rp-date-picker-header',
  standalone: true,
  templateUrl: './date-picker-header.component.html',
  styleUrl: './date-picker-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
})
export class DatePickerHeaderComponent<D> extends MatCalendarHeader<D> {
  iconName = IconName;

  private readonly _translate = inject(TranslateService);

  override get periodButtonText(): string {
    const { currentView, activeDate } = this.calendar;

    if (currentView === 'month') {
      const formatedDate: string = this['_dateAdapter'].format(
        activeDate,
        this['_dateFormats'].display.monthYearLabel,
      );

      const [month, year] = formatedDate.split(' ');
      const translatedMonth = this._getMonth(month.toLowerCase());

      return `${translatedMonth} ${year}`;
    }

    if (currentView === 'year') {
      return this['_dateAdapter'].getYearName(activeDate);
    }

    return this['_intl'].formatYearRange(...this['_formatMinAndMaxYearLabels']());
  }

  private _getMonth(monthShort: string): string {
    const monthsTranslations: string[] = [
      'general.labels.januaryShort',
      'general.labels.februaryShort',
      'general.labels.marchShort',
      'general.labels.aprilShort',
      'general.labels.mayShort',
      'general.labels.juneShort',
      'general.labels.julyShort',
      'general.labels.augustShort',
      'general.labels.septemberShort',
      'general.labels.octoberShort',
      'general.labels.novemberShort',
      'general.labels.decemberShort',
    ];

    const selectedMonth = monthsTranslations.find(m => m.includes(monthShort));

    return selectedMonth ? this._translate.instant(selectedMonth) : monthShort;
  }
}
